import React from "react";

import R from "ramda";

import { Box, Markup } from "src/components/base";

import Content from "./Content";

const Body = ({
  additionalBodyContent,
  content,
  theme,
  padded = true,
  pt = padded && 2, // Splitting py into pt and pb makes them overridable
  pb = padded && 2,
  px = padded && [3, 3, 4],
  style,
}) => (
  <Box pt={pt} pb={pb} px={px} theme={theme} style={style}>
    {content ? (
      <Markup
        html={R.path(["childMarkdownRemark", "html"], content)}
        theme={theme}
      />
    ) : null}
    {additionalBodyContent ? (
      <Content content={additionalBodyContent} dividers={false} />
    ) : null}
  </Box>
);

export default Body;

export const bodyFragment = graphql`
  fragment BodyContent on ContentfulBody {
    id
    __typename
    content {
      childMarkdownRemark {
        html
      }
    }
  }

  fragment Body on ContentfulBody {
    ...BodyContent
    additionalBodyContent {
      ...BodyContent
      ...Bio
      ...Module
      ...ItemGroupContents
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Content/Body.js